<template>
    <default-layout>

        <div class="row">
            <div class="col-12">
                <h1 class="h4">Import/Export</h1>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <a class="nav-item nav-link active"
                           id="nav-export-tab"
                           data-toggle="tab"
                           href="#nav-export"
                           role="tab"
                           aria-controls="nav-export"
                           aria-selected="false">
                            Export
                        </a>
                        <a class="nav-item nav-link disabled"
                           id="nav-profiles-tab"
                           data-toggle="tab"
                           href="#nav-profiles"
                           role="tab"
                           aria-controls="nav-profiles"
                           aria-selected="false">
                            Profiles
                        </a>
                    </div>
                </nav>
            </div>
        </div>
        <div class="row pt-4">

            <div class="col-12" v-if="loading === true">
                <spinner-component class="p-5" type="spinner-grow"/>
            </div>

            <div class="col-12" v-if="loading === false">
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-export" role="tabpanel" aria-labelledby="nav-export-tab">

                        <form @submit.prevent="onSubmit" class="container border p-4">

                            <div class="form-group row">
                                <label for="export-profile" class="col-sm-2 col-form-label">Export profile</label>
                                <div class="col-sm-10">
                                    <select id="export-profile" class="form-control" v-model="exportProfile" required="required">
                                        <option value="" disabled="disabled">-- Please select --</option>
                                        <option v-for="profile in exportProfiles"
                                                :key="profile.value"
                                                :value="profile.value">
                                            {{ profile.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="export-format" class="col-sm-2 col-form-label">Export format</label>
                                <div class="col-sm-10">
                                    <select id="export-format" class="form-control" v-model="exportFormat" required="required">
                                        <option value="" disabled="disabled">-- Please select --</option>
                                        <option v-for="format in exportFormats"
                                                :key="format.value"
                                                :value="format.value">
                                            {{ format.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <button class="btn btn-primary" :disabled="exportProfile === '' || exportFormat === ''">Export</button>
                        </form>

                    </div>
                    <div class="tab-pane fade" id="nav-profiles" role="tabpanel" aria-labelledby="nav-profiles-tab">
                        <p class="text-muted">Coming soon...</p>
                    </div>
                </div>
            </div>
        </div>

    </default-layout>
</template>

<script>
    import DefaultLayout from "../../components/layout/DefaultLayout";
    import moment from "moment";
    import SpinnerComponent from "../../components/ui/SpinnerComponent";

    export default {
        name: "ExportPage",
        components: {SpinnerComponent, DefaultLayout},
        computed: {
            exportData() {
                return this.$store.state.interactiveLink.executeExport;
            },
            exportProfiles() {
                return [
                    {
                        name: 'Default license',
                        value: 'a7d2bed5-475c-45e6-b64d-39ec8c1c4f79'
                    }
                ]
            },
            exportFormats() {
                return [
                    {
                        name: 'Comma-separated values (CSV)',
                        value: 'CSV'
                    }
                ]
            }
        },
        data() {
            return {
                loading: false,
                exportProfile: '',
                exportFormat: ''
            }
        },
        methods: {
            async onSubmit() {
                this.loading = true;
                await this.$store.dispatch('interactiveLink/executeExport', {
                    profile: this.exportProfile,
                    exportFormat: this.exportFormat
                });

                let fileContent;

                switch (this.exportFormat) {
                    default:
                    case 'CSV':
                        fileContent = 'data:text/csv;charset=utf-8,';
                        break;
                }

                fileContent += this.exportData;

                const data = encodeURI(fileContent);
                const link = document.createElement('a');
                const fileName = 'interactive-link-export-licenses-' + moment().format('YYYYMMDD-HHMMSS') + '.' + this.exportFormat.toLowerCase();
                link.setAttribute("href", data);
                link.setAttribute("download", fileName);
                link.click();
                this.loading = false;
            }
        }
    }
</script>

<style scoped>

</style>